import { render, staticRenderFns } from "./vip-rights.vue?vue&type=template&id=77766d92"
import script from "./vip-rights.vue?vue&type=script&lang=js"
export * from "./vip-rights.vue?vue&type=script&lang=js"
import style0 from "~/assets/scss/vip-rights.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports